import { useStoreWithEqualityFn } from 'zustand/traditional';
import { RouterState, useRouterStore } from './Router';

const navigateSelector = (s: RouterState) => s.navigate;
const isEqual = () => true;
export const useNavigate = () => {
  const store = useRouterStore();
  return useStoreWithEqualityFn(store, navigateSelector, isEqual);
};
